import type { IconNode } from '../types';

/**
 * @name whisk
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMiAzLjQ1IDIwLjU1IiAvPgogIDxwYXRoIGQ9Ik0zLjUgMTMuNWE1IDUgMCAxIDAgNy4xIDcuMUMxMi42IDE4LjYgMTUgOSAxNSA5cy05LjYgMi41LTExLjUgNC41IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/whisk
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const whisk: IconNode = [
  ['path', { d: 'M22 2 3.45 20.55', key: 'piomnp' }],
  [
    'path',
    { d: 'M3.5 13.5a5 5 0 1 0 7.1 7.1C12.6 18.6 15 9 15 9s-9.6 2.5-11.5 4.5', key: '1crn9o' },
  ],
];

export default whisk;
